<template>
    <div>
        <div role="alert" class="alert alert-danger" v-show=hideMessage>
            <div class="container">
                <div class="alert-header">
                    <attention class="svg-36 white-svg"></attention>
                    <div class="message-wrapper">
                        <h2 class="pl-3" v-html="message"  v-for="message in messages"></h2>
                    </div>
                    <span class="d-inline-block svg-36 white-svg" @click.prevent="hideMessage = !hideMessage">
                      <circle_close class="svg-36 white-svg"></circle_close>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Close from "./icons/close";
    import Attention from "./icons/attention";
    import Circle_close from "./icons/circle_close";
    export default {
      components: {Circle_close, Attention, Close},
      props: ['messages'],
        data() {
            return {
                hideMessage: true
            }
        }
    }
</script>
